import { FormControl, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
function SCUIDropdown({
    dataList,
    labelText,
    selectedValue,
    setSelectedValue,
    selectedFieldName,
    dropdownValueText,
}: any) {
    const getValue = () => {
        if (!selectedValue) return null;
        return (
            dataList.find((item: any) =>
                selectedFieldName === 'id' ? item.id === selectedValue : item.name === selectedValue
            ) || null
        );
    };

    const getOptionLabel = (option: any) => {
        if (!option) return '';
        return selectedFieldName === 'id' ? option.name : dropdownValueText ? option[dropdownValueText] : option.name;
    };

    return (
        <>
            {dataList && dataList.length > 0 && (
                <FormControl style={{ width: 300 }}>
                    <Autocomplete
                        value={getValue()}
                        onChange={(_, newValue) => {
                            setSelectedValue(selectedFieldName === 'id' ? newValue?.id : newValue?.name);
                        }}
                        options={dataList}
                        getOptionLabel={getOptionLabel}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={labelText}
                                sx={{
                                    '& input': {
                                        padding: '0 4px !important',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                    },
                                }}
                            />
                        )}
                        disablePortal
                        disableClearable
                    />
                </FormControl>
            )}
        </>
    );
}

export default SCUIDropdown;
